export default {
  instanceOrder: 'order',
  instanceRecurringSubscription: 'recurringSubscription',
  instanceLimitedSubscription: 'limitedSubscription',
  statusFree: 'free',
  statusCompleted: 'completed',
  statusRefunded: 'refunded',
  statusWaiting: 'waiting',
  statusFailed: 'failed',
  statusCancelled: 'cancelled',
  methodCC: 'CC',
  methodTerminal: 'terminal',
  methodCash: 'cash',
  methodPayLater: 'payLater',
  methodSavedCC: 'savedCC',
  methodInteracOnline: 'interacOnline',
  statusLabel(status) {
    switch(status) {
      case this.statusWaiting:
        return Core.Definition.getDefinition('En attente');
        break
      case this.statusCompleted:
        return Core.Definition.getDefinition('Complété');
        break
      case this.statusRefunded:
        return Core.Definition.getDefinition('Remboursé');
        break
      case this.statusCancelled:
        return Core.Definition.getDefinition('Annulé');
        break
      case this.statusFailed:
        return Core.Definition.getDefinition('Échoué');
        break
      case this.statusFree:
        return Core.Definition.getDefinition('Gratuit');
        break
      default:
        return ''
        break
    }
  },
  statusOptions(keys) {
    if (keys === undefined) {
      keys = [this.statusWaiting, this.statusCompleted, this.statusRefunded, this.statusCancelled, this.statusFailed ]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.statusLabel(key)
          }
      )
    }
    return options
  },
  methodLabel(method) {
    switch(method) {
      case this.methodCash:
        return Core.Definition.getDefinition('Comptant');
        break
      case this.methodTerminal:
        return Core.Definition.getDefinition('Terminal');
        break
      case this.methodCC:
        return Core.Definition.getDefinition('Carte de crédit');
        break
      case this.methodPayLater:
        return Core.Definition.getDefinition('Payer plus tard');
        break
      case this.methodSavedCC:
        return Core.Definition.getDefinition('Carte de crédit enregistrée');
        break
      case this.methodInteracOnline:
        return Core.Definition.getDefinition('Virement Interac');
        break
        return ''
        break
    }
  },
  methodOptions(keys) {
    if (keys === undefined) {
      keys = [this.methodCC, this.methodCash, this.methodTerminal, this.methodSavedCC]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.methodLabel(key)
          }
      )
    }
    return options
  }
}
